// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3lhDL","title":"ClientReferral_title__1Pu93","itemText":"ClientReferral_itemText__sfsVi"};